export default {"src":"/_next/static/media/0xdac17f958d2ee523a2206206994597c13d831ec7.fc08aec8.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};